/* Toolbar.tsx generated by @compiled/babel-plugin v0.38.1 */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
import "./Toolbar.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { useToolbarUI } from '../hooks/ui-context';
import { ResponsiveContainer, ResponsiveWrapper } from './ResponsiveContainer';
import { ToolbarKeyboardNavigationProvider } from './ToolbarKeyboardNavigationProvider';
import { ACTION_SUBJECT, ViewEventEmitter } from './ViewEventEmitter';
var styles = {
  toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
  toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
  toolbarResponsive: "_195gpxbi",
  primaryToolbar: "_bfhkvuon _1tkezwfg",
  toolbarSeparator: "_1mj714no",
  hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
  hiddenSelectorsPatch: "_z5m7glyw"
};
/**
 * A simple component representing a toolbar with box shadows - used to represent a secondary/floating toolbar
 *
 * @note: Responsiveness support replies on container query with container editor-area and media query
 */
export var Toolbar = function Toolbar(_ref) {
  var children = _ref.children,
    label = _ref.label,
    actionSubjectId = _ref.actionSubjectId,
    testId = _ref.testId;
  var isResponsiveEnabled = expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true);
  var toolbar = /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.toolbarBase, styles.toolbar, isResponsiveEnabled && styles.toolbarResponsive, isResponsiveEnabled && styles.hiddenSelectors, expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && styles.toolbarSeparator, expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && styles.hiddenSelectorsPatch),
    role: "toolbar",
    "aria-label": label,
    testId: testId,
    "data-toolbar-type": expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'inline' : undefined
  }, /*#__PURE__*/React.createElement(ViewEventEmitter, {
    actionSubject: ACTION_SUBJECT.TOOLBAR,
    actionSubjectId: actionSubjectId
  }), children);
  var wrappedToolbar = toolbar;
  var _useToolbarUI = useToolbarUI(),
    keyboardNavigation = _useToolbarUI.keyboardNavigation;
  if (keyboardNavigation) {
    var childComponentSelector = keyboardNavigation.childComponentSelector,
      dom = keyboardNavigation.dom,
      handleEscape = keyboardNavigation.handleEscape,
      handleFocus = keyboardNavigation.handleFocus,
      isShortcutToFocusToolbar = keyboardNavigation.isShortcutToFocusToolbar,
      ariaControls = keyboardNavigation.ariaControls,
      ariaLabel = keyboardNavigation.ariaLabel;
    wrappedToolbar = /*#__PURE__*/React.createElement(ToolbarKeyboardNavigationProvider, {
      childComponentSelector: childComponentSelector,
      dom: dom,
      isShortcutToFocusToolbar: isShortcutToFocusToolbar,
      handleEscape: handleEscape,
      handleFocus: handleFocus,
      ariaControls: ariaControls,
      ariaLabel: ariaLabel
    }, toolbar);
  }
  if (isResponsiveEnabled) {
    return /*#__PURE__*/React.createElement(ResponsiveWrapper, null, wrappedToolbar);
  }
  return wrappedToolbar;
};
/**
 *  A simple component representing a toolbar without box shadows - used to represent a primary toolbar
 */
export var PrimaryToolbar = function PrimaryToolbar(_ref2) {
  var children = _ref2.children,
    label = _ref2.label,
    breakpointPreset = _ref2.breakpointPreset,
    reducedBreakpoints = _ref2.reducedBreakpoints;
  if (expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true)) {
    return /*#__PURE__*/React.createElement(ResponsiveContainer, {
      breakpointPreset: breakpointPreset,
      reducedBreakpoints: reducedBreakpoints
    }, /*#__PURE__*/React.createElement(Box, {
      xcss: cx(styles.toolbarBase, styles.primaryToolbar, styles.hiddenSelectors),
      role: "toolbar",
      "aria-label": label,
      "data-toolbar-type": expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'primary' : undefined
    }, children));
  }
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.toolbarBase, styles.primaryToolbar),
    role: "toolbar",
    "aria-label": label,
    "data-toolbar-type": expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'primary' : undefined
  }, children);
};